import { Clear, Save } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import NormalTable from "../../../../Component/NormalTable";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import { color } from "../../../../StyleData/Config";
import { toast } from "react-toastify";
import * as Yup from "yup";
import ErrorProps from "../../../../Component/Errorprops";
import {
  DateTimePicker,
  LocalizationProvider,
  renderTimeViewClock,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { getDateWithOutUTC, toUTC } from "../../../../utils/dateUtil";

const AddLabour = ({
  editData,
  handleCloseClick,
  taskList = [],
  workOrderId,
  woDetail,
  type,
}) => {
  const [labourData, setLabourData] = useState([]);
  const [labourSelect, setLabourSelect] = useState([]);
  const [labourCompleteDetail, setLabourCompleteDetail] = useState([]);
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [planHours, setPlanHours] = useState("");
  const [errorTime, setErrorTime] = useState("");
  const [workedDate, setWorkedDate] = useState(null);
  const [workedHours, setWorkedHours] = useState("");
  const [errorWorked, setErrorWorked] = useState("");
  const [workCenterOptions, setWorkCenterOptions] = useState([]);
  const [selectedWorkCenterIds, setSelectedWorkCenterIds] = useState(
    (woDetail?.workCenterIdList || []).map((item) =>
      typeof item === "object" ? item.workCenterId : item,
    ),
  );
  const [labourLoading, setLabourLoading] = useState(false);

  useEffect(() => {
    getData();
  }, [woDetail]);

  const getData = async () => {
    try {
      const wcResponse = await axiosPrivate.get(
        "/selectlist/getallworkcenters",
      );
      setWorkCenterOptions(
        (wcResponse.data || []).filter(
          (wc) => wc.value && String(wc.text).toLowerCase() !== "none",
        ),
      );
    } catch (e) {
      setWorkCenterOptions([]);
    }

    const wcIds = (woDetail?.workCenterIdList || []).map((item) =>
      typeof item === "object" ? item.workCenterId : item,
    );
    if (wcIds.length === 0) return;

    setLabourLoading(true);
    try {
      const labourLink = masterAPI["labourCraft"].getlaboursbyworkcenters;
      const res = await axiosPrivate.post(labourLink, wcIds);
      setLabourData(res.data.result || []);
    } catch (e) {
      setLabourData([]);
      console.log(e, "labourCraft error");
    }
    setLabourLoading(false);
  };

  const updateWorkOrderIfNeeded = async () => {
    const originalList = woDetail?.workCenterIdList || [];
    const original = originalList.map((item) =>
      typeof item === "object" ? item.workCenterId : item,
    );
    const changed =
      selectedWorkCenterIds.length !== original.length ||
      selectedWorkCenterIds.some((id) => !original.includes(id));
    if (changed && woDetail) {
      const updateLink = masterAPI["workOrder"].updateWorkcenter;
      const payload = selectedWorkCenterIds.map((id) => {
        const existing = originalList.find(
          (item) =>
            (typeof item === "object" ? item.workCenterId : item) === id,
        );
        return {
          workCenterId: id,
          isDefault: existing ? existing.isDefault === true : false,
        };
      });
      await axiosPrivate.put(`${updateLink}/${workOrderId}`, payload);
    }
  };

  const handleGetLabour = async (wcIds) => {
    if (!wcIds || wcIds.length === 0) {
      toast.error("Please select a work center");
      return;
    }
    const ids = wcIds.map((item) =>
      typeof item === "object" ? item.workCenterId : item,
    );
    setLabourLoading(true);
    try {
      const labourLink = masterAPI["labourCraft"].getlaboursbyworkcenters;
      const res = await axiosPrivate.post(labourLink, ids);
      setLabourData(res.data.result || []);
    } catch (e) {
      setLabourData([]);
      console.log(e, "labourCraft error");
    }
    setLabourLoading(false);
  };

  const timeSchema = Yup.object({
    planHours: Yup.string()
      .required("Time is required")
      .matches(/^\d+:[0-5]\d$/, "Format must be HH:MM and minutes 00-59"),
  });

  const workedSchema = Yup.object({
    workedHours: Yup.string()
      .required("Time is required")
      .matches(/^\d+:[0-5]\d$/, "Format must be HH:MM and minutes 00-59"),
  });

  const validatePlanHours = (value) => {
    try {
      timeSchema.validateSync({ planHours: value }, { abortEarly: false });
      setErrorTime("");
    } catch (err) {
      setErrorTime(err.errors[0]);
    }
  };

  const validateWorkedHours = (value) => {
    try {
      workedSchema.validateSync({ workedHours: value }, { abortEarly: false });
      setErrorWorked("");
    } catch (err) {
      setErrorWorked(err.errors[0]);
    }
  };

  const handleCheck = (value) => {
    if (labourSelect.includes(value.id)) {
      setLabourSelect(labourSelect.filter((l) => l !== value.id));
      setLabourCompleteDetail(
        labourCompleteDetail.filter(
          (l) =>
            l.labourId !== value.labourId &&
            l.workCenterId !== value.workCenterId &&
            l.craftId !== value.craftId,
        ),
      );
    } else {
      setLabourSelect([...labourSelect, value.id]);
      setLabourCompleteDetail([...labourCompleteDetail, value]);
    }
  };

  const handleSubmit = async () => {
    if (selectedTasks.length === 0) {
      toast.error("Please select at least one task");
      return;
    }
    if (labourCompleteDetail.length === 0) {
      toast.error("Please select at least one labour");
      return;
    }

    if (type === "assigned") {
      try {
        timeSchema.validateSync({ planHours }, { abortEarly: false });
      } catch (err) {
        setErrorTime(err.errors[0]);
        return;
      }
    } else {
      if (!workedDate) {
        toast.error("Please select worked date");
        return;
      }
      try {
        workedSchema.validateSync({ workedHours }, { abortEarly: false });
      } catch (err) {
        setErrorWorked(err.errors[0]);
        return;
      }
    }

    const wotlink = masterAPI["workOrderTaskLabour"].bulkinsert;
    const taskIds = selectedTasks.map((t) => t.id);

    await updateWorkOrderIfNeeded();

    if (type === "assigned") {
      const decimalPlanHours =
        Number(planHours.split(":")[0]) + Number(planHours.split(":")[1]) / 60;
      const payload = [];
      for (const taskId of taskIds) {
        for (const lab of labourCompleteDetail) {
          payload.push({
            workOrderTaskId: taskId,
            labourId: lab.labourId,
            workOrderId: workOrderId,
            businessId:lab.businessId||null,
            craftId: lab.craftId,
            workCenterId: lab.workCenterId || null,
            quantity: 1,
            plannedHours: decimalPlanHours,
            rate: lab.rateForRegularHors,
            cost: lab.rateForRegularHors * decimalPlanHours,
            plannedCost: lab.rateForRegularHors * decimalPlanHours,
            isAssignedLabour: true,
          });
        }
      }
      try {
        await axiosPrivate.post(`${wotlink}`, payload);
        toast.success("Labour saved successfully");
        handleCloseClick();
      } catch (e) {
        console.log(e);
        toast.error("Failed to save labour");
      }
    } else {
      const decimalWorkedHours =
        Number(workedHours.split(":")[0]) +
        Number(workedHours.split(":")[1]) / 60;
      const payload = [];
      for (const taskId of taskIds) {
        for (const lab of labourCompleteDetail) {
          payload.push({
            workCenterId: lab.workCenterId || null,
            workOrderTaskId: taskId,
            workOrderId: workOrderId,
            labourId: lab.labourId,
            jobPlanTaskLabourId: lab.jobPlanTaskLabourId || null,
            businessId: lab.businessId || null,
            craftId: lab.craftId,
            quantity: lab.quantity || 1,
            plannedHours: lab.plannedHours || 0,
            workedDate: toUTC(workedDate).utcISOString,
            workedHours: decimalWorkedHours,
            rate: lab.rateForRegularHors,
            cost: lab.rateForRegularHors * decimalWorkedHours,
            plannedCost: lab.plannedCost || 0,
            actualCost: lab.rateForRegularHors * decimalWorkedHours,
            isActualLabour: true,
          });
        }
      }
      try {
        await axiosPrivate.post(`${wotlink}`, payload);
        toast.success("Labour saved successfully");
        handleCloseClick();
      } catch (e) {
        console.log(e);
      }
    }
  };

  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: ({ cell }) => {
        const row = cell.row.original;
        return (
          <Checkbox
            checked={labourCompleteDetail.some(
              (ex) =>
                ex.labourId === row.labourId &&
                ex.workCenterId === row.workCenterId &&
                ex.craftId === row.craftId,
            )}
            onClick={() => handleCheck(row)}
          />
        );
      },
    },
    {
      Header: "Labour Name",
      accessor: "labourName",
    },
    {
      Header: "Craft Name",
      accessor: "craftName",
    },
    {
      Header: "Work Center",
      accessor: "workCenterName",
    },
  ];

  return (
    <Grid container sx={{ p: 1 }} spacing={"1.5rem"}>
      <Grid item xs={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: color.masterDialogTitleColor,
              fontSize: "1.1rem",
              fontWeight: 500,
            }}
          >
            Add Labour
          </Typography>
          <Box>
            <IconButton onClick={handleSubmit}>
              <Save sx={{ color: "#2362B4" }} />
            </IconButton>
            <IconButton onClick={handleCloseClick}>
              <Clear />
            </IconButton>
          </Box>
        </Box>
        <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)" }} />
      </Grid>

      {/* Task multi-select */}
      <Grid item xs={12}>
        <Typography
          sx={{
            fontWeight: color.labelFontWeight,
            fontSize: color.labelFont,
            mb: color.labelmb,
          }}
        >
          Select Tasks :
        </Typography>
        <Autocomplete
          multiple
          options={taskList}
          getOptionLabel={(option) => `${option.taskNo} - ${option.taskName}`}
          value={selectedTasks}
          onChange={(e, newValue) => setSelectedTasks(newValue)}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                label={`${option.taskNo} - ${option.taskName}`}
                size="small"
                {...getTagProps({ index })}
              />
            ))
          }
          renderInput={(params) => (
            <TextField {...params} size="small" placeholder="Select tasks" />
          )}
        />
      </Grid>

      {/* Hours fields — shown only when tasks are selected */}
      {selectedTasks.length > 0 && (
        <>
          {/* Work Center multiselect */}
          <Grid item xs={12}>
            <Typography
              sx={{
                fontWeight: color.labelFontWeight,
                mb: color.labelmb,
                fontSize: color.labelFont,
              }}
            >
              Work Center
            </Typography>
            <Box sx={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
              <Autocomplete
                multiple
                fullWidth
                options={workCenterOptions}
                getOptionLabel={(option) => option.text || ""}
                isOptionEqualToValue={(option, val) =>
                  option.value === val.value
                }
                getOptionDisabled={(option) => {
                  const defaultIds = (woDetail?.workCenterIdList || [])
                    .filter((item) => item.isDefault === true)
                    .map((item) =>
                      typeof item === "object" ? item.workCenterId : item,
                    );
                  return defaultIds.includes(option.value);
                }}
                value={workCenterOptions.filter((wc) =>
                  selectedWorkCenterIds.includes(wc.value),
                )}
                onChange={(_, newValue) => {
                  const ids = newValue.map((v) => v.value);
                  const isRemoval = ids.length < selectedWorkCenterIds.length;
                  if (isRemoval && labourSelect.length > 0) {
                    toast.warning(
                      "You have unsaved labour selections. Please save before changing the work center.",
                    );
                  }
                  setSelectedWorkCenterIds(ids);
                  handleGetLabour(ids);
                }}
                renderTags={(tagValue, getTagProps) => {
                  const defaultIds = (woDetail?.workCenterIdList || [])
                    .filter((item) => item.isDefault === true)
                    .map((item) =>
                      typeof item === "object" ? item.workCenterId : item,
                    );
                  return tagValue.map((option, index) => {
                    const { key, ...tagProps } = getTagProps({ index });
                    const isDefault = defaultIds.includes(option.value);
                    return (
                      <Chip
                        key={key}
                        {...tagProps}
                        label={option.text}
                        onDelete={isDefault ? undefined : tagProps.onDelete}
                      />
                    );
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Select Work Center"
                  />
                )}
              />
            </Box>
          </Grid>
          {type === "assigned" ? (
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  fontWeight: color.labelFontWeight,
                  fontSize: color.labelFont,
                  mb: color.labelmb,
                }}
              >
                Planned Hours(HH:MM) :
              </Typography>
              <TextField
                name="plannedHours"
                size="small"
                fullWidth
                placeholder="HH:MM"
                value={planHours}
                onChange={(e) => {
                  setPlanHours(e.target.value);
                  validatePlanHours(e.target.value);
                }}
                onBlur={(e) => {
                  validatePlanHours(e.target.value);
                }}
              />
              <ErrorProps>{errorTime}</ErrorProps>
            </Grid>
          ) : (
            <>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    fontSize: color.labelFont,
                    mb: color.labelmb,
                  }}
                >
                  Worked Date :
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoItem>
                    <DateTimePicker
                      ampm={false}
                      format="DD/MM/YYYY HH:mm"
                      viewRenderers={{
                        hours: renderTimeViewClock,
                        minutes: renderTimeViewClock,
                        seconds: renderTimeViewClock,
                      }}
                      value={workedDate ? dayjs(workedDate) : null}
                      slotProps={{
                        textField: { size: "small", fullWidth: true },
                      }}
                      onChange={(newValue) => {
                        if (newValue && `${newValue.$d}` !== "Invalid Date") {
                          setWorkedDate(getDateWithOutUTC(newValue));
                        }
                      }}
                    />
                  </DemoItem>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    fontSize: color.labelFont,
                    mb: color.labelmb,
                  }}
                >
                  Worked Hours(HH:MM) :
                </Typography>
                <TextField
                  name="workedHours"
                  size="small"
                  fullWidth
                  placeholder="HH:MM"
                  value={workedHours}
                  onChange={(e) => {
                    setWorkedHours(e.target.value);
                    validateWorkedHours(e.target.value);
                  }}
                  onBlur={(e) => {
                    validateWorkedHours(e.target.value);
                  }}
                />
                <ErrorProps>{errorWorked}</ErrorProps>
              </Grid>
            </>
          )}

          {/* Labour table */}
          <Grid item xs={12}>
            <Typography
              sx={{
                color: color.masterDialogTitleColor,
                fontSize: "1rem",
                fontWeight: 500,
                mb: 1,
              }}
            >
              Labour List
            </Typography>
            <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: 1 }} />
            {labourLoading ? (
              <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                <CircularProgress size={28} />
              </Box>
            ) : (
              <NormalTable data={labourData} columns={columns} filt={true} />
            )}
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default AddLabour;
